(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4369);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9831);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1720);
/* harmony import */ var _components_SectionContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(890);
/* harmony import */ var _data_animerdle_list_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8984);
/* harmony import */ var _data_gameSchedule__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6601);
/* harmony import */ var _data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2010);
/* harmony import */ var utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2536);
/* harmony import */ var utils_encryption__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(771);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_guess_bars_SkipBar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2852);
/* harmony import */ var _components_guess_bars_FailedBar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1688);
/* harmony import */ var _components_guess_bars_CurrentBar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6896);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var mailgo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5107);
/* harmony import */ var mailgo__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(mailgo__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);

















const DynamicPlayController = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(()=>__webpack_require__.e(/* import() */ 362).then(__webpack_require__.bind(__webpack_require__, 9362)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9362)
            ]
    }
});
function Home(param) {
    let { totalStats  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)();
    const animeList = _data_animerdle_list_json__WEBPACK_IMPORTED_MODULE_5__;
    const [todayAnime, setTodayAnime] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null);
    const [soundUrl, setSoundUrl] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const getPreviousRoundIndex = ()=>{
        const scheduleLength = parseInt(Object.keys((_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default())).length);
        const keyIndex = (0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)() % scheduleLength // this will be null
        ;
        return Object.keys((_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default()))[keyIndex - 1];
    };
    const updateTodayAnime = ()=>{
        let schedule = (_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default())[(0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)()];
        if ((_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default())[(0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)()] === undefined) {
            const scheduleLength = parseInt(Object.keys((_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default())).length);
            const keyIndex = (0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)() % scheduleLength // this will be null
            ;
            const key = Object.keys((_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default()))[keyIndex];
            schedule = (_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default())[key];
            console.log("schedule", schedule);
        }
        let additionals = "";
        if (schedule.id !== undefined) {
            additionals = "_audio".concat(schedule.audioNum);
            schedule = schedule.id;
        }
        const _todayAnime = animeList.find((x)=>x.id === schedule);
        const audioName = "".concat(_todayAnime.id.toString());
        setTodayAnime(_todayAnime);
        setSoundUrl("static/assets/anime/".concat((0,utils_encryption__WEBPACK_IMPORTED_MODULE_15__/* .SHA1 */ .O)(audioName)).concat(additionals, ".mp3"));
    };
    const setStatsInLocalStorage = (_currentGameStats)=>{
        if (true) {
            let stats = localStorage.getItem("stats");
            if (stats != null) {
                stats = JSON.parse(stats);
                const s = stats.find((x)=>x.day === (0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)());
                if (s != null) {
                    s.actions = _currentGameStats.actions;
                    localStorage.setItem("stats", JSON.stringify(stats));
                } else {
                    stats.push(_currentGameStats);
                    localStorage.setItem("stats", JSON.stringify(stats));
                }
            } else {
                localStorage.setItem("stats", JSON.stringify([
                    _currentGameStats
                ]));
            }
        }
    };
    const updateRanking = (stats)=>{
        const roundsWon = stats.filter((x)=>x.actions.find((i)=>i.win));
        totalStats.rounds = [
            ...Array(6)
        ].fill(0);
        let avgRoundWin = 0;
        for(let i = 0; i < stats.length; i++){
            for(let j = 0; j < stats[i].actions.length; j++){
                if (stats[i].actions[j].win) {
                    totalStats.rounds[j] += 1;
                    avgRoundWin += stats[i].actions[j].attemptNum + 1;
                }
            }
        }
        if (avgRoundWin > 0) {
            avgRoundWin /= roundsWon.length;
            totalStats.avgRoundWin = Math.round(avgRoundWin * 10) / 10;
        }
        totalStats.played = stats.length;
        totalStats.won = roundsWon.length;
        totalStats.avgRoundWin = Math.round(avgRoundWin * 10) / 10;
    };
    const [currentGameStats, setCurrentGameStats] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        day: (0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)(),
        malId: (_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default())[(0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)()],
        actions: []
    });
    const resetCurrentGameStats = ()=>{
        setCurrentGameStats({
            day: (0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)(),
            malId: (_data_gameSchedule__WEBPACK_IMPORTED_MODULE_6___default())[(0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)()],
            actions: []
        });
    };
    const [currentAttemptNum, setCurrentAttemptNum] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [action, setAction] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([
        ...Array("", "", "", "", "", "")
    ]);
    const [submittedAnime, setSubmittedAnime] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    for(let i = 0; i < currentGameStats.actions.length; i++){
        if (currentGameStats.actions[i].skip) {
            action[i] = "skip";
        }
        if (currentGameStats.actions[i].failedGuess) {
            const anime = animeList.find((x)=>x.id === currentGameStats.actions[i].animeId);
            submittedAnime[i] = anime.title;
            action[i] = "failedguess";
        }
        if (currentGameStats.actions[i].win) {
            const anime1 = animeList.find((x)=>x.id === currentGameStats.actions[i].animeId);
            submittedAnime[i] = anime1.title;
            action[i] = "correctguess";
        }
    }
    const [isDataReady, setIsDataReady] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const updateStatsFromLocalStorage = ()=>{
        if (true) {
            let stats = localStorage.getItem("stats");
            if (stats != null) {
                stats = JSON.parse(stats);
                const s = stats.find((x)=>x.day === (0,utils_dateHelper__WEBPACK_IMPORTED_MODULE_14__/* .getDayOfTheYear */ .c)());
                updateRanking(stats);
                if (s != null) {
                    setCurrentGameStats(s);
                    setCurrentAttemptNum(s.actions.length);
                    const hasWon = s.actions.find((x)=>x.win);
                    if (hasWon) {
                        setFinishedGameState(true);
                        activateTimerToNextDay();
                        setWin(true);
                    } else if (s.actions.length === 6) {
                        setFinishedGameState(true);
                        activateTimerToNextDay();
                    }
                }
            }
            let firstTime = localStorage.getItem("firstTime");
            if (firstTime == null) {
                firstTime = false;
                localStorage.setItem("firstTime", firstTime);
            // setHowToPlayModal(true)  // Todo fix this
            }
            setIsDataReady(true);
        }
    };
    const mailgoConfig = {
        dark: true
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        updateStatsFromLocalStorage();
        updateTodayAnime();
        mailgo__WEBPACK_IMPORTED_MODULE_16___default()(mailgoConfig);
    }, []);
    const [win, setWin] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [finishedGame, setFinishedGame] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const finishedGameStateRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(finishedGame);
    const setFinishedGameState = (data)=>{
        finishedGameStateRef.current = data;
        setFinishedGame(data);
    };
    const [opaqueExceptPlay, setOpaqueExceptPlay] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const theme = (0,next_themes__WEBPACK_IMPORTED_MODULE_7__/* .useTheme */ .F)();
    const resetToInitialState = ()=>{
        const temp = [
            ...Array("", "", "", "", "", "")
        ];
        setAction(temp);
        setCurrentAttemptNum(0);
        setSubmittedAnime([]);
        resetCurrentGameStats();
        setFinishedGameState(false);
    };
    const onSubmit = (anime)=>{
        if (todayAnime.id === anime.id) {
            // player won, show him finishedGame screen
            const temp = action;
            temp[currentAttemptNum] = "correctguess";
            setAction(temp);
            setFinishedGameState(true);
            setWin(true);
            updateStatsFromLocalStorage();
            currentGameStats.actions[currentAttemptNum] = {
                attemptNum: currentAttemptNum,
                win: true,
                skip: false,
                failedGuess: false,
                animeId: anime.id
            };
            setStatsInLocalStorage(currentGameStats);
            activateTimerToNextDay();
            // update ranking
            updateStatsFromLocalStorage();
        } else {
            let temp1 = submittedAnime;
            temp1[currentAttemptNum] = anime.title;
            setSubmittedAnime(temp1);
            temp1 = action;
            temp1[currentAttemptNum] = "failedguess";
            setAction(temp1);
            updateAttempt();
            updateStatsFromLocalStorage();
            currentGameStats.actions[currentAttemptNum] = {
                attemptNum: currentAttemptNum,
                win: false,
                skip: false,
                failedGuess: true,
                animeId: anime.id
            };
            setCurrentGameStats(currentGameStats);
            setStatsInLocalStorage(currentGameStats);
            if (currentAttemptNum === 5) {
                // update ranking
                updateStatsFromLocalStorage();
                setFinishedGameState(true);
            }
        }
    };
    const onSkip = ()=>{
        let temp = action;
        temp[currentAttemptNum] = "skip";
        setAction(temp);
        updateAttempt();
        updateStatsFromLocalStorage();
        currentGameStats.actions[currentAttemptNum] = {
            attemptNum: currentAttemptNum,
            win: false,
            skip: true,
            failedGuess: false,
            animeId: null
        };
        setCurrentGameStats(currentGameStats);
        setStatsInLocalStorage(currentGameStats);
        if (currentAttemptNum === 5) {
            // update ranking
            updateStatsFromLocalStorage();
            setFinishedGameState(true);
        }
    };
    // time until next animerdle
    const [hoursUntil, setHoursUntil] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [minutesUntil, setMinutesUntil] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const [secondsUntil, setSecondsUntil] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    let tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    let countDownDate = tomorrow.getTime();
    const resetClock = ()=>{
        const today = new Date();
        tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(24, 0, 0, 0);
        countDownDate = tomorrow.getTime();
    };
    const activateTimerToNextDay = ()=>{
        const x = setInterval(function() {
            // Get today's date and time
            const now = new Date().getTime();
            // Find the distance between now and the count-down date
            const distance = countDownDate - now;
            // Time calculations for days, hours, minutes and seconds
            const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
            const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
            const seconds = Math.floor(distance % (1000 * 60) / 1000);
            setHoursUntil(hours);
            setMinutesUntil(minutes);
            setSecondsUntil(seconds);
            // If the count down is finished
            if (distance < 0) {
                resetClock();
                updateTodayAnime();
                resetToInitialState();
            }
        }, 1000);
    };
    const updateAttempt = ()=>{
        setCurrentAttemptNum(currentAttemptNum + 1);
    };
    // Render Guess Bars
    const renderResultBar = (barNum)=>{
        if (!action[barNum]) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_guess_bars_CurrentBar__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                isSelected: currentAttemptNum === barNum
            });
        } else {
            if (action[barNum] === "failedguess") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_guess_bars_FailedBar__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    failedGuess: submittedAnime[barNum]
                });
            }
            if (action[barNum] === "skip") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_guess_bars_SkipBar__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_SEO__WEBPACK_IMPORTED_MODULE_1__/* .PageSEO */ .TQ, {
                title: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_2___default().title),
                description: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_2___default().description),
                keywords: "anime guessing game, animerdle"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_SectionContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: "flex h-full flex-col justify-between",
                    children: isDataReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
                        children: [
                            finishedGame ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("main", {
                                className: "flex h-full flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                        "aria-label": "Go to today's anime guess site",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                            href: "",
                                            className: "text-left",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                                className: "flex min-h-[9rem]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                        className: "rounded-l",
                                                        src: todayAnime.image_url,
                                                        alt: "Today's Animerdle cover picture",
                                                        title: "Today's Animerdle cover picture",
                                                        width: 160,
                                                        height: 200
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                                        className: "w-full rounded-md border-gray-700 bg-gray-300 p-5 dark:bg-gray-800",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                                            className: "flex h-full flex-col justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                                                    className: "text-xl font-bold text-gray-800 dark:text-gray-200",
                                                                    children: todayAnime.title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("p", {
                                                                    className: "text-sm text-gray-600 dark:text-gray-400",
                                                                    children: [
                                                                        "Type: ",
                                                                        todayAnime.type
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("p", {
                                                                    className: "text-sm text-gray-600 dark:text-gray-400",
                                                                    children: [
                                                                        "Status: ",
                                                                        todayAnime.status
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                                                className: "flex justify-center font-bold",
                                                children: [
                                                    win && "You guessed today's Animerdle!",
                                                    !win && "You didn't guess today's Animerdle."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                                className: "flex justify-center text-sm text-gray-400",
                                                children: [
                                                    win && "Good job, you know your Anime.",
                                                    !win && "Better luck next time!"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                                className: "flex justify-center gap-2",
                                                children: action.map((s, index)=>{
                                                    let color = "";
                                                    if (theme.theme === "dark") {
                                                        if (s === "skip") color = "gray";
                                                        if (s === "failedguess") color = "#A93226";
                                                        if (s === "correctguess") color = "green";
                                                        if (s === "") color = "white";
                                                    } else {
                                                        if (s === "skip") color = "#212F3C";
                                                        if (s === "failedguess") color = "red";
                                                        if (s === "correctguess") color = "green";
                                                        if (s === "") color = "#AEB6BF";
                                                    }
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
                                                        className: "h-5 w-5 ",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("circle", {
                                                            className: "opacity-50",
                                                            style: {
                                                                stroke: "".concat(color)
                                                            },
                                                            cx: "12",
                                                            cy: "12",
                                                            r: "10",
                                                            strokeWidth: "3"
                                                        })
                                                    }, index);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                        className: "mb-5 flex flex-col items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                                className: "text-sm text-gray-500",
                                                children: "Next Animerdle in"
                                            }),
                                            hoursUntil <= 0 && minutesUntil <= 0 && secondsUntil <= 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
                                                className: "-ml-1 mr-3 h-5 w-5 animate-spin text-white",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("circle", {
                                                        className: "opacity-25",
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10",
                                                        stroke: "currentColor",
                                                        strokeWidth: "4"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                                                        className: "opacity-75",
                                                        fill: "currentColor",
                                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                                                className: "text-xl",
                                                children: [
                                                    ("0" + hoursUntil).slice(-2),
                                                    ":",
                                                    ("0" + minutesUntil).slice(-2),
                                                    ":",
                                                    ("0" + secondsUntil).slice(-2)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("main", {
                                className: "flex h-full flex-col justify-between",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                    className: "relative flex flex-col justify-between",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                        className: "grid grid-cols-1 gap-2",
                                        children: [
                                            renderResultBar(0),
                                            renderResultBar(1),
                                            renderResultBar(2),
                                            renderResultBar(3),
                                            renderResultBar(4),
                                            renderResultBar(5)
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "".concat(opaqueExceptPlay && "absolute top-0 left-0 h-full w-full bg-black opacity-70")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                    "aria-label": "Submit guess",
                                    className: "rounded bg-primary-600 py-2 px-4 text-sm font-semibold text-white hover:bg-primary-700 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-primary-700",
                                    onClick: ()=>{
                                        router.push("/classic/".concat(getPreviousRoundIndex()));
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                        children: "Previous Round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(DynamicPlayController, {
                                onSubmit: onSubmit,
                                onSkip: onSkip,
                                currentAttemptNum: currentAttemptNum,
                                setCurrentAttemptNum: setCurrentAttemptNum,
                                updateAttempt: ()=>updateAttempt(),
                                finishedGameStateRef: finishedGameStateRef,
                                todayAnime: todayAnime,
                                setOpaqueExceptPlay: setOpaqueExceptPlay,
                                opaqueExceptPlay: opaqueExceptPlay,
                                currentGameStats: currentGameStats,
                                soundUrl: soundUrl
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,107,391,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);